module.exports = __webpack_public_path__ + "img/PDM-600-Mobile.afb8efd3.webp";